import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=db0b4d82&scoped=true"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0b4d82",
  null
  
)

export default component.exports